import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { HostListener } from '@angular/core';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { ShorttermpaydetailsComponent } from '../shorttermpaydetails/shorttermpaydetails.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';
@Component({
  selector: 'app-addshorttermpay',
  templateUrl: './addshorttermpay.component.html',
  styleUrls: ['./addshorttermpay.component.css']
})
export class AddshorttermpayComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "ShorttermPay";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isshowapproval: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;

  ismanualclose: boolean;

  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isemploading: boolean = false;
  //Edit Get Values
  shorttermpaydetailColl: any = [];

  shorttermpayColl: any = [];
  shorttermpayid: number = 0

  shorttermpayBO: any = {};

  salarytypeColl: any = [];
  emppayColl: any = [];
  emppaytotal: any = 0;

  totallowanceamt: any = 0
  totdeductionamt: any = 0
  totsalaryamt: any = 0

  departmentColl: any = [];
  designationColl: any = [];
  gradeColl: any = [];

  empColl: any = [];
  empBO: any = {};

  checkfeildmsg: any = ""

  shorttermpayform = new FormGroup({
    shorttermpayid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    effectivefromdt: new FormControl(null, Validators.required),
    effectivetodt: new FormControl(null, Validators.required),
    transdt: new FormControl(null, Validators.required),
    amount: new FormControl(null, Validators.required),
    descr: new FormControl(''),
    inactive: new FormControl(false),
  });



  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.shorttermpayid = params.id
      }
    });
    this.fnGetParameterVariable();
    this.fnServiceChanges();
    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }

  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
    })
  }

  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.shorttermpayform.reset();
      this.fnInitializeFormGroup();

      if (this.shorttermpayid > 0) {
        this.fngetshorttermpay();
      }
      this.fngetEmployee();
      // this.fnGetSalaryType();
      // this.fngetDepartment();
      // this.fngetDesignation();
      //this.fngetGrade();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.shorttermpayid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }


    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.shorttermpayform.setValue({
      shorttermpayid: 0,
      empid: null,
      effectivefromdt: this.loginService.fnLastDate(new Date()),
      effectivetodt: this.loginService.fnLastDate(new Date()),
      transdt: new Date(),
      amount: null,

      descr: '',

      inactive: false
    })
  }



  fngetEmployee() {
    this.isemploading = true;
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading = false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading = false;
          this.toastr.error('Error', err);
        })
  }



  //Get 
  fngetshorttermpay() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'shorttermpayid': this.shorttermpayid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getShorttermPay(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            console.log(res.json().result)

            this.shorttermpayColl = res.json().result[0];


            this.shorttermpaydetailColl = []
            this.shorttermpaydetailColl = res.json().result[1];

            this.fnCalculateTotal();


            var editdata = this.shorttermpayColl[0];
            this.shorttermpayBO = editdata;
            this.fnEditMode(editdata);


          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }
  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.shorttermpayform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      if (this.loginService.fnCheckFornControlNotfound(this.shorttermpayform.get('effectivefromdt'))) {
        this.shorttermpayform.controls['effectivefromdt'].setErrors(null);
      }
      if (this.loginService.fnCheckFornControlNotfound(this.shorttermpayform.get('effectivetodt'))) {
        this.shorttermpayform.controls['effectivetodt'].setErrors(null);
      }

      if (this.loginService.fnCheckFornControlNotfound(this.shorttermpayform.get('amount'))) {
        this.shorttermpayform.controls['amount'].setErrors(null);
      }

      if (this.loginService.fnCheckFornControlNotfound(this.shorttermpayform.get('inactive'))) {
        this.shorttermpayform.controls['inactive'].setErrors(null);
      }


      //Validate   
      if (this.shorttermpayform.valid) {

        if (this.shorttermpaydetailColl.length === 0) {
          this.shorttermpayform.controls['amount'].setErrors({ 'required': true });
          return;
        }


        if (this.loginService.fnCompareDateValidation(this.shorttermpayform.get('effectivefromdt').value, this.shorttermpayform.get('transdt').value)) {
          this.shorttermpayform.controls['effectivefromdt'].setErrors({ 'notfound': true });
          return
        }

        if (this.loginService.fnCompareDateValidation(this.shorttermpayform.get('effectivetodt').value, this.shorttermpayform.get('effectivefromdt').value)) {
          this.shorttermpayform.controls['effectivetodt'].setErrors({ 'notfound': true });
          return
        }

        this.saveloading = true;


        //Check
        var data = {
          'shorttermpayid': this.shorttermpayid,
          'effectivefromdt': this.fnFormatDatetime(this.shorttermpayform.get('effectivefromdt').value),
          'effectivetodt': this.fnFormatDatetime(this.shorttermpayform.get('effectivetodt').value),
          'transdt': this.fnFormatDatetime(this.shorttermpayform.get('transdt').value),
          'empid': this.shorttermpayform.get('empid').value,
          'amount': this.shorttermpayform.get('amount').value,
          'inactive': this.shorttermpayform.get('inactive').value,

          'descr': this.shorttermpayform.get('descr').value,

          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'shorttermpaydetailscoll': this.shorttermpaydetailColl
        }

        this.appService.fnCheckShorttermPay(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresponce = res.json().result[0];

              var _checkresult = _checkresponce.checkfield;

              if (_checkresult === 'done') {

                if (this.shorttermpayform.get('shorttermpayid').value > 0) {
                  //Update 
                  this.fnSetShorttermpay(data);
                }
                else {
                  //Insert 
                  this.fnInsertShorttermpay(data);
                }
              }
              else {
                if (_checkresult === "COMMON") {
                  this.saveloading = false;

                  this.checkfeildmsg = _checkresponce.checkvaluemsg;

                  this.shorttermpayform.controls['inactive'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });



      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertShorttermpay(data) {

    this.appService.fnInsertShorttermPay(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag()
            this.toastr.success('', "The new shorttermpay has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));

            var _result = res.json().result;
            if (_result) {
              this.fnEditFormEdit(_result);
            }

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetShorttermpay(data) {

    this.appService.fnSetShorttermPay(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          console.log(res.json().result);
          if (res.json().result != "") {
            this.fnResetSaveFlag()
            this.toastr.success('', "The shorttermpay has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.shorttermpayid, this.fngetDescriptionRefno(data));

            this.fnEditFormEdit(this.shorttermpayid);

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }
  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }

  fnEditFormEdit(id) {

    this.shorttermpayid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
    }


    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ismanualclose = true;
      window.location.reload();
    });

  }

  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;

      let navigationExtras: NavigationExtras = {
        queryParams: {
          'status': this.filterstatus,
          'empid': this.filteremployeeid,
          'empname': this.filteremployeename,
          'fromdate': this.fnFormatDatetime(this.filterfromdate),
          'todate': this.fnFormatDatetime(this.filtertodate),
        }
      }

      this.router.navigate(['/ShorttermPay'], navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Grid

  fnAddShorttermpayDetails(type) {

    const modalRef = this.productFindService.open(ShorttermpaydetailsComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = type;
    modalRef.componentInstance.shorttermpaydetailColl = this.shorttermpaydetailColl;
    modalRef.componentInstance.fnSetValidator();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.shorttermpaydetailColl.push(receivedEntry);
      this.fnCalculateTotal();

    });
  }


  fnEditshorttermpayDetails(index, type) {


    const modalRef = this.productFindService.open(ShorttermpaydetailsComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = type;

    var data = this.shorttermpaydetailColl[index];

    modalRef.componentInstance.shorttermpaydetid = data.shorttermpaydetid;
    modalRef.componentInstance.allowanceid = data.allowanceid;
    modalRef.componentInstance.deductionid = data.deductionid;
    modalRef.componentInstance.amount = data.amount;

    modalRef.componentInstance.shorttermpaydetailColl = this.shorttermpaydetailColl;

    modalRef.componentInstance.fnSetValidator();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.shorttermpaydetailColl[index].shorttermpaydetid = receivedEntry.shorttermpaydetid;
      this.shorttermpaydetailColl[index].allowanceid = receivedEntry.allowanceid;
      this.shorttermpaydetailColl[index].amount = receivedEntry.amount;
      this.shorttermpaydetailColl[index].deductionid = receivedEntry.deductionid;

      this.fnCalculateTotal();

    });

  }

  fnDeleteshorttermpayConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.shorttermpaydetailColl.splice(index, 1);
            this.fnCalculateTotal();
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    deptBO.effectivefromdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.effectivefromdt));
    deptBO.effectivetodt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.effectivetodt));
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    //deptBO.promoeffectivedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.promoeffectivedt));
    this.shorttermpayform.setValue({
      shorttermpayid: deptBO.shorttermpayid,
      empid: deptBO.empid,
      effectivefromdt: deptBO.effectivefromdt,
      effectivetodt: deptBO.effectivetodt,
      transdt: deptBO.transdt,
      amount: deptBO.amount,

      descr: deptBO.descr,
      inactive: deptBO.inactive
    });

    // this.fngetEmpByEmpid();

    this.formmode = "Edit";


    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();
    this.fnChangeEmpLookup();
    this.fnGetAttachmentCount();
  }

  fnCalculateTotal() {

    this.totallowanceamt = 0;
    this.totdeductionamt = 0;
    this.totsalaryamt = 0;

    for (let abo of this.shorttermpaydetailColl) {
      if (abo.allowanceid > 0) {
        this.totallowanceamt = this.totallowanceamt + abo.amount;
      }
      else if (abo.deductionid > 0) {
        this.totdeductionamt = this.totdeductionamt + abo.amount;
      }
    }

    this.totsalaryamt = this.totallowanceamt - this.totdeductionamt;


    this.shorttermpayform.patchValue({
      amount: this.totsalaryamt
    });
  }



  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetshorttermpay();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.shorttermpayBO.approvedstatus !== '') {
      if (this.shorttermpayBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.shorttermpayBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }
  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.shorttermpayid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();


    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetshorttermpay();
      }
    });



  }


  fnAttachmentSave(tid) {



  }

  fnSetAttachmentCount(data) {

    this.attachmentcount = data;
  }

  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.shorttermpayid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetshorttermpay();
      }


    });
  }


  //Suspend
  fnSetSuspendConfirm(type) {

    var displaytxt = "";

    if (type === "SUSPEND") {
      displaytxt = "Suspend"
    }
    else if (type === "UNSUSPEND") {
      displaytxt = "UnSuspend"
    }

    this.confirmationDialogService.confirm('Confirm..', 'Do you  want to ' + displaytxt + ' this Shorttermpay?')
      .then((confirmed) => {
        if (confirmed) {
          if (type === "SUSPEND") {
            this.fnSetSuspend(true)
          }
          else if (type === "UNSUSPEND") {
            this.fnSetSuspend(false)
          }

        }
      }
      );
  }

  fnSetSuspend(issuspend) {

    if (this.shorttermpayid > 0) {
      var data = {
        'shorttermpayid': this.shorttermpayid,
        'issuspend': issuspend,
        'modifiedby': this.loginService.fnGetModUserId(),
      }


      this.appService.fnSetShorttermPaySuspend(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fngetshorttermpay()
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }



  //Attachment
  fnGetAttachmentCount() {
    if (this.shorttermpayid > 0) {
      var data = {
        'trxid': this.shorttermpayid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }
  fnAddActivity() {

    const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.shorttermpayid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });

  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  fnResetSaveFlag() {
    this.submitted = false;
    this.successfully = false;
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}